import Reviews from "@/components/Reviews";
import EditorialMarquee from "@/components/EditorialMarquee";
import Seo from "@/components/Seo";

export default function WordOfMouth() {
  return (
    <main data-testid="word-of-mouth-page" className="pt-16 md:pt-20">
      <Seo
        title="Word of Mouth — Reserve 30 Parfums"
        description="Worn. Noticed. Reviewed. What customers across India say about Reserve 30 Parfums."
      />
      <Reviews />
      <EditorialMarquee />
    </main>
  );
}
